export const ALLOWED_EMAIL_DOMAIN =
  process.env.REACT_APP_ALLOWED_EMAIL_DOMAIN || 'sensestack.com.au';

export function isAllowedEmail(email) {
  if (!email || typeof email !== 'string') return false;
  const value = email.trim().toLowerCase();
  return value.endsWith(`@${ALLOWED_EMAIL_DOMAIN.toLowerCase()}`);
}

